(function () {
    'use strict';
    var interactionEvents = ['keydown', 'mousemove', 'wheel', 'touchmove', 'touchstart', 'touchend', 'click'];
    var delayedTimeout;

    function handleDelayed() {
        window.dispatchEvent(new Event("Delayed"));
    }

    function handleFirstInteraction() {
        window.optPef.isFirstInteractive = false;

        clearTimeout(delayedTimeout);

        window.dispatchEvent(new Event("FirstInteractive"));

        console.log('Execute FirstInteractive');

        interactionEvents.forEach(function (event) {
            window.removeEventListener(event, handleFirstInteraction, false);
        });
    }

    window.addEventListener("load", function () {
        const { pageName } = window.optPef;

        let delayTime = 20000;

        handleDelayed();

        delayedTimeout = setTimeout(() => {
            if (!window.optPef.isFirstInteractive) return;

            handleFirstInteraction();
        }, delayTime);

        interactionEvents.forEach(function (event) {
            window.addEventListener(event, handleFirstInteraction, false);
        });
    }, {
        once: true
    });

})();